import { useEffect } from "react"
import { type WorkBook } from "xlsx"
import { DataColumn } from "../types"

interface Props {
    workbook: WorkBook | undefined
    selectedSheet: string
    setAllColumns: (columns: DataColumn[]) => void
    setColumnsSelected?: (columns: string[]) => void
    setDimensions: (dimensions: { rows: number; columns: number }) => void
}

export function useDatasetMetadata({
    workbook,
    selectedSheet,
    setAllColumns,
    setColumnsSelected,
    setDimensions,
}: Props) {
    useEffect(() => {
        if (!workbook) {
            return
        }
        if (selectedSheet === "") {
            return
        }

        import("xlsx").then(({ utils }) => {
            const sheet = workbook.Sheets[selectedSheet]
            const dataset = utils.sheet_to_json<string[]>(sheet, { header: 1 })
            const [headers, ...data] = dataset
            const columns = headers
                .map((column, index) => ({
                    label: column,
                    id: `c-${index}`,
                    position: index,
                    cells: [],
                }))
                .filter((c) => c) as { label: string; position: number; cells: string[]; id: string }[]

            let rowCount = 0
            const colCount = headers.length
            for (const [i, row] of data.entries()) {
                for (let j = 0; j < colCount; j++) {
                    if (row[j]) {
                        rowCount = i + 1
                    }
                }
            }

            for (const [i] of headers.entries()) {
                for (let j = 0; j < rowCount; j++) {
                    columns.find((c) => c.id === `c-${i}`)?.cells.push(data[j][i])
                }
            }

            setAllColumns(columns)
            setColumnsSelected && setColumnsSelected(columns.map((c) => c.id))
            setDimensions({ rows: rowCount, columns: colCount })
        })
    }, [workbook, selectedSheet, setAllColumns, setColumnsSelected, setDimensions])
}
